export const styles = {
  specificMembersLabel: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#131F1E',
    marginBottom: '8px',
  },
  optionAvatar: { width: '24px', height: '24px', border: '2px solid #FFFFFF', borderRadius: '4px' },
  optionText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
    marginLeft: '12px',
  },
  optionBox: { display: 'flex', alignItems: 'center' },
  textField: {
    '& .MuiInputBase-root': {
      paddingTop: '0',
      height: '36px',
      background: 'white',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      outline: 'none',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: 0,
      },
      '&:hover fieldset': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  selectedItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px 6px',
    gap: '8px',
    background: '#E7ECFF', // Primary / 200
    border: '1px solid #F3F4F9', // Grey/200
    borderRadius: '8px',
  },
  selectedItemText: {
    height: '20px',
    fontFamily: 'Inter', // body/tertiary - regular
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '130%', // or 20px
    color: '#23252F', // Grey/900
  },
  removeIcon: { cursor: 'pointer' },
  selectedItemsParentBox: {
    display: 'flex',
    gap: '6px',
    width: '550px',
    flexFlow: 'wrap',
    marginTop: '10px',
    marginBottom: '22px',
  },
  groupNameLabel: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#131F1E',
    marginBottom: '8px',
  },
  groupNameTextInput: {
    '& .MuiInputBase-root': {
      height: '36px',
      background: 'white',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      outline: 'none',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: 0,
      },
      '&:hover fieldset': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  saveAudienceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    cursor: 'pointer',
    marginBottom: '22px',
  },
  saveAudienceText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '148%',
    color: '#23252F',
  },
};
